import http from 'hub-http/clients/apiClient';
import { bulkSubscriptionUpdate } from 'subscriptions-client/routes/BulkUpdate';
import { doiState } from 'subscriptions-client/utils/constants';
import { SELECTION_METHOD_BY_QUERY } from 'customer-data-bulk-actions/constants/selectionMethods';
const BASE_URL = '/data-privacy-settings/hub-settings';
export const performBulkUpdateDoubleOptInStatus = ({
  isDoubleOptedIn,
  selectionState
}) => {
  const {
    selectionMethod,
    selectionCrmSearchQuery,
    selectionIds
  } = selectionState;
  const basePayload = {
    doiState: isDoubleOptedIn ? doiState.CUSTOMER_CONFIRMED : doiState.RESET_NULL_STATE
  };
  const payload = selectionMethod === SELECTION_METHOD_BY_QUERY ? Object.assign({}, basePayload, {
    contactsSearch: Object.assign({}, selectionCrmSearchQuery)
  }) : Object.assign({}, basePayload, {
    vids: selectionIds
  });
  return bulkSubscriptionUpdate({
    // See this thread for context: https://hubspot.slack.com/archives/CRV0Q5D5K/p1664469769825379
    // @ts-expect-error This payload is accurate despite what the schema that defines this param type thinks
    data: Object.assign({}, payload)
  });
};
export const getDataPrivacySettings = () => http.get(BASE_URL);